<template>
    <div class="home">
        <v-container fill-height class="pt-0">
            <h2 class="mb-3">Post Sev Details</h2>
            <report-filter :report-filter-override="reportFilterOverride"  ref="reportFilter"></report-filter>

            <v-row>
                <v-col cols="6">
                    <v-skeleton-loader v-show="isBusy"
                                       height="80"
                                       type="image"></v-skeleton-loader>
                    <v-card width="100%" class="text-center" v-show="!isBusy">
                        <div class="pt-3">
                            MTTR (Minutes) <v-btn x-small color="primary" icon @click="onOpenMttrCaption">
                                <v-icon class="text-right">mdi-help-circle</v-icon>
                            </v-btn>
                        </div>
                        <div class="text-h5 pb-3">{{ meanTimeSummary.mttr }}</div>
                    </v-card>
                </v-col>
                <v-col cols="6">
                    <v-skeleton-loader v-show="isBusy"
                                       height="80"
                                       type="image"></v-skeleton-loader>
                    <v-card width="100%" class="text-center" v-show="!isBusy">
                        <div class="pt-3">
                            MTTC (Minutes) <v-btn x-small color="primary" icon @click="onOpenMttcCaption">
                                <v-icon class="text-right">mdi-help-circle</v-icon>
                            </v-btn>
                        </div>
                        <div class="text-h5 pb-3">{{ meanTimeSummary.mttc }}</div>
                    </v-card>
                </v-col>
            </v-row>


            <v-row v-for="row in reportLayouts" :key="row.id">
                <v-col cols="12" :key="chart.chartId" v-for="chart in row.cols" :md="chart.colSpan" xs="12" sm="12">
                    <chart-view :chart-id="chart.chartId"
                                :chart-type="chart.chartType"
                                :report-filter-override="reportFilterOverride"
                                @on-operator-select="onOperatorSelect"
                                @on-severity-select="onSeveritySelect"
                                :report-layout-id="chart.reportLayoutId"
                                @replaced="onReplaced"></chart-view>
                </v-col>
            </v-row>
            <!--<v-row>
        <v-col cols="12">
            <v-btn outlined
                   rounded
                   @click="isChartSelectorVisible = !isChartSelectorVisible"
                   text>
                EDIT MODE
            </v-btn>
        </v-col>
    </v-row>-->
        </v-container>
    </div>
</template>

<script>
    import ChartView from "../../components/charts/ChartView"
    import ReportFilter from "../../components/reports/ReportFilter"
    import ReportLayoutService from "../../services/reportLayoutService"
    import MetricService from "../../services/metricService"
    import moment from 'moment';
    import { EventBus } from '../../event/event-bus.js';


    export default {
        name: 'PostSevDetails',
        data: function () {
            return {
                isBusy: true,
                accessToken: null,
                reportLayouts: [],
                reportFilterOverride: {
                    startDate: moment().subtract(30, "days").format(moment.HTML5_FMT.DATE),
                    startTime: "00:00",
                    endDate: moment().format(moment.HTML5_FMT.DATE),
                    endTime: "23:59",
                    selectedOperatorBrands: [],
                    selectedIncidentTypes: [],
                    selectedSites: [],
                    startDateAndTime: null,
                    endDateAndTIme: null,
                    selectedResponsibleTeams: [],
                },
                meanTimeSummary: {
                    mttc: 0,
                    mttr: 0
                }
            }
        },
        components: {
            ReportFilter,
            ChartView
        },
        methods: {
            async setup() {
                this.accessToken = this.$auth.getAccessToken();

                await this.getMeanTimeSummary();
                await this.getReportLayout("PostSevDetails");
            },
            async getReportLayout(name) {
                let results = await ReportLayoutService.getReportLayoutsByName(name, false, this.accessToken);

                let reportRows = [];

                results.forEach(function (item) {

                    if (!reportRows[item.row - 1]) {
                        reportRows.push({
                            cols: [
                                {
                                    chartId: item.chartId,
                                    chartType: item.chartType,
                                    reportLayoutId: item.id,
                                    colSpan: item.colSpan
                                }
                            ]
                        });
                    }
                    else {
                        reportRows[item.row - 1].cols.push({
                            chartId: item.chartId,
                            chartType: item.chartType,
                            reportLayoutId: item.id,
                            colSpan: item.colSpan
                        });
                    }

                });

                this.reportLayouts = reportRows;
            },
            getCols(cols) {
                return Math.floor(12 / cols);
            },
            onChartSelectorClose() {
                this.isChartSelectorVisible = false;
            },
            onReplaced() {
                this.reportLayouts = [];
                this.getReportLayout("PostSevDetails");
            },
            async getMeanTimeSummary() {
                this.isBusy = true;
                let chartRequest = {
                    startDate: moment.utc(`${this.reportFilterOverride.startDate} ${this.reportFilterOverride.startTime}`),
                    endDate: moment.utc(`${this.reportFilterOverride.endDate} ${this.reportFilterOverride.endTime}`),
                    chartFilterOverrides: this.getChartFilterOverrides()
                };

                this.meanTimeSummary = await MetricService.getMeanTimeSummary(chartRequest, this.accessToken);

                this.isBusy = false;

            },
            onOpenMttrCaption() {
                EventBus.$emit('emit-caption', 'mttr');
            },
            onOpenMttcCaption() {
                EventBus.$emit('emit-caption', 'mttc');
            },
            getChartFilterOverrides() {

                let filters = [];

                //operator
                if (this.reportFilterOverride.selectedOperatorBrands) {
                    filters.push({
                        "columnName": "AffectedOperator",
                        "columnFilters": this.reportFilterOverride.selectedOperatorBrands
                    });
                }

                //incident types
                if (this.reportFilterOverride.selectedIncidentTypes) {
                    filters.push({
                        "columnName": "IncidentSeverity",
                        "columnFilters": this.reportFilterOverride.selectedIncidentTypes
                    });
                }

                //sites
                if (this.reportFilterOverride.selectedSites) {
                    filters.push({
                        "columnName": "AffectedSite",
                        "columnFilters": this.getSelectedSites()
                    });
                }

                return filters;
            },
            getSelectedSites() {

                let selectedSites = [];

                if (this.reportFilterOverride.selectedSites) {

                    this.reportFilterOverride.selectedSites.forEach(site => {
                        selectedSites.push(site);
                    })

                    //Work around for name changes
                    if (selectedSites.some(site => site === "MAL") && !selectedSites.some(site => site === "Malta")) {
                        selectedSites.push("Malta");
                    }

                    if (selectedSites.some(site => site === "GIC") && !selectedSites.some(site => site === "Gibraltar")) {
                        selectedSites.push("Gibraltar");
                    }

                    if (selectedSites.some(site => site === "CIL") && !selectedSites.some(site => site === "Croatia")) {
                        selectedSites.push("Croatia");
                    }
                }

                return selectedSites;
            },
            onOperatorSelect(evt) {
                this.reportFilterOverride.selectedOperatorBrands = [];

                var operatorBrands = this.$refs.reportFilter.getOperatorBrands();

                operatorBrands.forEach(brand => {
                    if (brand.toLowerCase() === evt.toLowerCase()) {
                        this.reportFilterOverride.selectedOperatorBrands.push(brand);
                    }
                });
            },
            onSeveritySelect(evt) {
                this.reportFilterOverride.selectedIncidentTypes = [];
                this.reportFilterOverride.selectedIncidentTypes.push(evt);
            }
        },
        created() {
            this.setup();
        },
        watch: {
            deep: true,
            immediate: true,
            reportFilterOverride: {
                handler() {
                    this.getMeanTimeSummary();
                },
                deep: true
            },
        }
    }
</script>
